import { useListRebalancerClients } from '../../../../api/rebalancer'

export const usePreloadListRebalancerClients = () => {
  useListRebalancerClients()
}
